var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrfrsSimboloFundoVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5abaa3;}.cls-3{fill:#fff;}.cls-4{fill:#26397f;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#f1c61a;}.cls-7{fill:#e9e674;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.11,437.37h0l.21-.2Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1000,
    height: 1000
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.93,745.29s-51.29,3-67.15-34.36c-15.59-36.72,6.26-73.66,67.15-101.61s86.95-69.88,81.85-108.55S554,460.06,554,460.06l28.66,4.4s26.9,20.46,26.69,52.69c-.22,36.06-15,89.57-106.76,128.46-49.22,20.85-56.72,53.67-56.72,53.67l9.17-1.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M638,694.35c-27,19.68-81.25,50.91-153.56,51a.67.67,0,0,1-.52-.25l-31.62-41.39a.64.64,0,0,1,.56-1c12.4,1.53,100.23,11,181.4-15.49A4.09,4.09,0,0,1,638,694.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500,420s-33.27-19.09-62-45c-26.42-23.86-31.7-44.63-30.87-59.65S423.9,274,453,270.68s27.2,14.51,25.47,18.84c-4.2,10.36-.37,14.88,8.25,25.76,9.78,12.34,37.65,41.2,56.52,37,6.49-1.45,8-63.55-7.26-79.11s-46.6-38.52-88-36.7c-43.05,1.88-79.69,42.87-77.58,83,2.09,39.6,8.48,58.4,52.27,100.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M536.52,420s61.67-96.18,130.87-136.23a57.61,57.61,0,0,1,28.9-7.65h3a4,4,0,0,1,2.6,7.08c-10.8,9.18-30.67,26.58-52.19,48-25.8,25.62-48.74,56.1-68.39,88.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M621.11,437.37H378.86c22.78,22.34,53,43.19,53.33,63.4.41,26.39-58.82,49.88-58.82,70.73,0,25.73,111.31,192.15,126.57,192.15H500c15.26,0,126.56-166.42,126.56-192.15,0-20.85-58.81-44.34-58.81-70.73C567.78,491.43,598.33,459.71,621.11,437.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M621.11,437.37h0l.21-.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 621.12,
    y: 437.18,
    width: 0.2,
    height: 0.2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M567.78,500.77c5.1,38.67-20.95,80.61-81.85,108.55s-82.79,61.33-67.15,101.61c0,0,32.43-4.57,27.12-11.66-4.21-5.63,9.14-30.47,56.72-52.27,90.62-41.52,106.54-93.79,106.76-129.85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M364.78,414.13H635.2A4.11,4.11,0,0,1,638,421.2l-16.92,16.17H378.86L361.94,421.2A4.11,4.11,0,0,1,364.78,414.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrfrsSimboloFundoVerde);
export default __webpack_public_path__ + "static/media/crfrs-simbolo-fundo-verde.159650161576b93d08937bc9ae7eab88.svg";
export { ForwardRef as ReactComponent };